const aiEndpoints = {
  voices: "/v1/cms/ai/voices",
  voicesCatalog: "/v1/cms/ai/voices/catalog",
  voicesSearch: "/v1/cms/ai/voices/search",
  voicePreview: "/v1/cms/ai/voices/preview",
  tts: "/v1/cms/ai/tts",
  translateRouteModes: "/v1/cms/ai/translate/route_modes",
  translateGeneric: "/v1/cms/ai/translate/generic",
  generateRouteModes: "/v1/cms/ai/generate/route_modes",
  generateRouteModesContent: "/v1/cms/ai/generate/route_modes/content",
  generateRouteModesDirections: "/v1/cms/ai/generate/route_modes/directions",
  generateRouteModesParking: "/v1/cms/ai/generate/route_modes/parking",
  generateRouteModesImages: "/v1/cms/ai/generate/route_modes/images",
  generateRouteModesMusic: "/v1/cms/ai/generate/route_modes/music",
  mixRouteModesAudio: "/v1/cms/ai/generate/route_modes/mix",
  aiPrompts: "/v1/cms/ai/prompts",
};

export default aiEndpoints;
